(function () {
  'use strict';

  // Ab dieser Anzahl Ausführungen muss eine konkrete Ausführung gewählt werden
  var MAX_TAGS_PER_SEARCH = 12;

  function parseYears(str) {
    var out = [];
    if (!str) return out;
    String(str).split(',').forEach(function (part) {
      var p = part.split('-');
      var a = parseInt(p[0], 10);
      var b = p.length > 1 ? parseInt(p[1], 10) : a;
      if (isNaN(a) || isNaN(b)) return;
      for (var y = a; y <= b; y++) out.push(y);
    });
    return out;
  }

  class VehicleFinder extends HTMLElement {
    constructor() {
      super();
      this.data = null;
      this.entries = [];
      this.candidates = [];
      this.selectedTags = [];
      this.herstellerEl = this.querySelector('[data-role="hersteller"]');
      this.modellEl = this.querySelector('[data-role="modell"]');
      this.baujahrEl = this.querySelector('[data-role="baujahr"]');
      this.varianteEl = this.querySelector('[data-role="variante"]');
      this.varianteField = this.querySelector('[data-role="variante-field"]');
      this.submitEl = this.querySelector('[data-role="submit"]');
      this.resetEl = this.querySelector('[data-role="reset"]');
      this.statusEl = this.querySelector('[data-role="status"]');
      this.ph = {
        hersteller: this.herstellerEl.options[0] ? this.herstellerEl.options[0].textContent : '',
        modell: this.modellEl.options[0] ? this.modellEl.options[0].textContent : '',
        baujahr: this.baujahrEl.options[0] ? this.baujahrEl.options[0].textContent : '',
        variante: this.varianteEl.options[0] ? this.varianteEl.options[0].textContent : ''
      };
    }

    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.loadData();
      this.herstellerEl.addEventListener('change', () => this.onHerstellerChange());
      this.modellEl.addEventListener('change', () => this.onModellChange());
      this.baujahrEl.addEventListener('change', () => this.onBaujahrChange());
      this.varianteEl.addEventListener('change', () => this.onVarianteChange());
      this.submitEl.addEventListener('click', () => this.onSubmit());
      this.resetEl.addEventListener('click', () => this.reset());
    }

    setStatus(message, state) {
      if (!this.statusEl) return;
      if (!message) {
        this.statusEl.hidden = true;
        this.statusEl.textContent = '';
        this.statusEl.removeAttribute('data-state');
        return;
      }
      this.statusEl.hidden = false;
      this.statusEl.textContent = message;
      if (state) this.statusEl.setAttribute('data-state', state);
      else this.statusEl.removeAttribute('data-state');
    }

    async loadData() {
      var url = this.dataset.jsonUrl;
      if (!url) {
        this.setStatus('Fahrzeugdaten konnten nicht geladen werden.', 'error');
        return;
      }
      try {
        var response = await fetch(url);
        if (!response.ok) throw new Error('HTTP ' + response.status);
        this.data = await response.json();
        this.populateHersteller();
      } catch (error) {
        this.setStatus('Fahrzeugdaten konnten nicht geladen werden. Bitte Seite neu laden.', 'error');
      }
    }

    fill(selectEl, placeholder, options) {
      selectEl.innerHTML = '';
      var first = document.createElement('option');
      first.value = '';
      first.textContent = placeholder;
      selectEl.appendChild(first);
      (options || []).forEach(function (o) {
        var opt = document.createElement('option');
        opt.value = o[0];
        opt.textContent = o[1];
        selectEl.appendChild(opt);
      });
    }

    hideVariante() {
      this.fill(this.varianteEl, this.ph.variante);
      this.varianteEl.disabled = true;
      if (this.varianteField) this.varianteField.hidden = true;
    }

    setTags(tags) {
      this.selectedTags = tags || [];
      this.submitEl.disabled = !this.selectedTags.length;
    }

    populateHersteller() {
      if (!this.data) return;
      var names = Object.keys(this.data).sort(function (a, b) { return a.localeCompare(b, 'de'); });
      this.fill(this.herstellerEl, this.ph.hersteller, names.map(function (n) { return [n, n]; }));
      this.herstellerEl.disabled = false;
    }

    onHerstellerChange() {
      var hersteller = this.herstellerEl.value;
      this.fill(this.modellEl, this.ph.modell);
      this.fill(this.baujahrEl, this.ph.baujahr);
      this.modellEl.disabled = true;
      this.baujahrEl.disabled = true;
      this.hideVariante();
      this.setTags([]);
      this.setStatus('');
      if (!hersteller || !this.data[hersteller]) return;

      var modelle = Object.keys(this.data[hersteller]).sort(function (a, b) {
        return a.localeCompare(b, 'de', { numeric: true });
      });
      this.fill(this.modellEl, this.ph.modell, modelle.map(function (m) { return [m, m]; }));
      this.modellEl.disabled = false;
    }

    onModellChange() {
      var hersteller = this.herstellerEl.value;
      var modell = this.modellEl.value;
      this.fill(this.baujahrEl, this.ph.baujahr);
      this.baujahrEl.disabled = true;
      this.hideVariante();
      this.setTags([]);
      this.setStatus('');
      this.entries = [];
      if (!hersteller || !modell || !this.data[hersteller] || !this.data[hersteller][modell]) return;

      // Eintrag: [Ausführung, Tag, Baujahre]
      this.entries = this.data[hersteller][modell].map(function (e) {
        return { name: e[0], tag: e[1], years: parseYears(e[2]) };
      });

      var yearSet = {};
      var withoutYears = 0;
      this.entries.forEach(function (e) {
        if (!e.years.length) withoutYears++;
        e.years.forEach(function (y) { yearSet[y] = true; });
      });
      var years = Object.keys(yearSet).map(Number).sort(function (a, b) { return b - a; });

      if (!years.length) {
        // Für dieses Modell sind keine Baujahre hinterlegt: direkt Ausführung wählen
        this.showVarianten(this.entries);
        return;
      }

      var options = years.map(function (y) { return [String(y), String(y)]; });
      if (withoutYears) options.push(['none', 'Baujahr nicht dabei / unbekannt']);
      this.fill(this.baujahrEl, this.ph.baujahr, options);
      this.baujahrEl.disabled = false;

      if (years.length === 1 && !withoutYears) {
        this.baujahrEl.value = String(years[0]);
        this.onBaujahrChange();
      }
    }

    onBaujahrChange() {
      var value = this.baujahrEl.value;
      this.hideVariante();
      this.setTags([]);
      this.setStatus('');
      if (!value) return;

      var list;
      if (value === 'none') {
        list = this.entries.filter(function (e) { return !e.years.length; });
      } else {
        var year = parseInt(value, 10);
        list = this.entries.filter(function (e) { return e.years.indexOf(year) !== -1; });
      }
      this.showVarianten(list);
    }

    showVarianten(list) {
      this.candidates = list.slice().sort(function (a, b) {
        return a.name.localeCompare(b.name, 'de', { numeric: true });
      });
      if (!this.candidates.length) return;

      if (this.candidates.length === 1) {
        this.setTags([this.candidates[0].tag]);
        return;
      }

      var mustChoose = this.candidates.length > MAX_TAGS_PER_SEARCH;
      var first = mustChoose
        ? this.ph.variante
        : 'Alle Ausführungen (' + this.candidates.length + ')';
      this.fill(this.varianteEl, first, this.candidates.map(function (e) { return [e.tag, e.name]; }));
      this.varianteEl.disabled = false;
      if (this.varianteField) this.varianteField.hidden = false;
      this.mustChoose = mustChoose;
      this.setTags(mustChoose ? [] : this.candidates.map(function (e) { return e.tag; }));
    }

    onVarianteChange() {
      var tag = this.varianteEl.value;
      if (tag) {
        this.setTags([tag]);
      } else {
        this.setTags(this.mustChoose ? [] : this.candidates.map(function (e) { return e.tag; }));
      }
    }

    onSubmit() {
      if (!this.selectedTags.length) return;
      var searchUrl = this.dataset.searchUrl || '/search';
      var query = this.selectedTags.map(function (t) { return "tag:'" + t + "'"; }).join(' OR ');
      window.location.href = searchUrl + '?q=' + encodeURIComponent(query) + '&type=product';
    }

    reset() {
      this.populateHersteller();
      this.herstellerEl.value = '';
      this.fill(this.modellEl, this.ph.modell);
      this.fill(this.baujahrEl, this.ph.baujahr);
      this.modellEl.disabled = true;
      this.baujahrEl.disabled = true;
      this.hideVariante();
      this.entries = [];
      this.candidates = [];
      this.setTags([]);
      this.setStatus('');
    }
  }

  if (!customElements.get('vehicle-finder')) {
    customElements.define('vehicle-finder', VehicleFinder);
  }
})();
